/**
 * Наши сообщества по теме курса.
 * apps/web/src/components/CourseChannels.tsx
 *
 * Человек, который дочитал курс про воду, интересуется темой, а не только курсом.
 * Зовём туда, где мы говорим о ней постоянно. Список приходит с сервера — меняется
 * без пересборки сайта.
 */

import { useEffect, useState } from 'react';

interface Channel {
  platform: string;
  url: string;
  note?: string;
}
/** Группа сообществ одного направления: свои курсы и свои площадки. */
interface PromoGroup {
  direction?: string;
  title: string;
  intro?: string;
  channels: Channel[];
  /** Курсы этого направления. Пусто — группа годится для всех. */
  courses?: string[];
}
interface Promo {
  groups?: PromoGroup[];
}

export default function CourseChannels({ collectionId }: { collectionId: string }) {
  const [group, setGroup] = useState<PromoGroup | null>(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/promo')
      .then((r) => (r.ok ? r.json() : null))
      .then((d: Promo | null) => {
        if (!alive) return;
        // Берём группу своего направления: пустой список курсов = группа для всех
        const found = (d?.groups || []).find(
          (g) => !g.courses?.length || g.courses.includes(collectionId)
        );
        if (found?.channels?.length) setGroup(found);
      })
      .catch(() => {
        /* нет списка — нет блока */
      });
    return () => {
      alive = false;
    };
  }, [collectionId]);

  if (!group) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm">
      <h2 className="text-lg font-bold text-gray-900">{group.title}</h2>
      {group.intro && <p className="text-sm text-gray-500 mt-1">{group.intro}</p>}
      <div className="mt-4 grid gap-2">
        {group.channels.map((c) => (
          <a
            key={c.url}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-baseline gap-2 rounded-xl border border-gray-100 px-4 py-3
                       hover:border-blue-200 hover:bg-blue-50 transition-colors"
          >
            <span className="font-medium text-gray-900">{c.platform}</span>
            {c.note && <span className="text-sm text-gray-500">— {c.note}</span>}
          </a>
        ))}
      </div>
    </div>
  );
}
